import { extendedPropertyFlags, extendedPropertyFlagsEnum, extendedPropertyKinds } from "helpers/enums";
import { enumLabel, flagVal } from "helpers/system";
import React from "react";
import { deleteItem } from "sources/extendedProperties";

const invisibleFlagVal = flagVal(extendedPropertyFlags, extendedPropertyFlagsEnum.Invisible);
const requiredFlagVal = flagVal(extendedPropertyFlags, extendedPropertyFlagsEnum.Required);

const OrganizationPropertyItem = (props) => {
    const { id, displayName, kind, propertyName, typeCode, defaultValue, intFlags, description } = props;
    const editProperty = () => {
        return props.modal({
            name: "extendedPropertyForm",
            title: "Редактирование",
            data: props,
            windowMod: "wide",
            callback: () => props.getItem(),
        });
    };

    const deleteProperty = () => {
        return props.modal({
            name: "confirm",
            title: "Удаление поля",
            text: "Вы уверены, что хотите удалить поле?",
            onSuccessAction: () => props.getItem(),
            action: () => deleteItem({ id }),
            buttons: { confirm: "Да", cancel: "Нет" },
        });
    };

    return (
        <tr>
            <td>{id}</td>
            <td>{displayName}</td>
            <td>{description}</td>
            <td>{enumLabel(extendedPropertyKinds, kind)}</td>
            <td>{propertyName}</td>
            <td>{typeCode}</td>
            <td>{defaultValue}</td>
            <td>{(intFlags & invisibleFlagVal) === invisibleFlagVal ? "Да" : "Нет"}</td>
            <td>{(intFlags & requiredFlagVal) === requiredFlagVal ? "Да" : "Нет"}</td>
            <td>
                <div className="inline-btn inline-btn--edit" onClick={editProperty}>
                    Изменить
                </div>
                <div className="ml-2 inline-btn inline-btn--delete" onClick={deleteProperty}>
                    Удалить
                </div>
            </td>
        </tr>
    );
};

export default OrganizationPropertyItem;
